import Log from '../utils/Log';
import { NETWORK_IDS, NETWORK_NAMES, GTM_ENVIRONMENTS } from './constants';
//import DeployedContracts from './deployedContracts-development.json';
//import DeployedContracts from './deployedContracts-development_kovan.json';
//import DeployedContracts from './deployedContracts-development_ropsten.json';
//import DeployedContracts from './deployedContracts-development_rinkeby.json';
//import DeployedContracts from './deployedContracts-test_rinkeby.json';
import DeployedContracts from './deployedContracts-mainnet.json';

const networks = {
  development: {
    id: NETWORK_IDS.DEVELOPMENT,
    name: NETWORK_NAMES.DEVELOPMENT,
    fallbackProvider: 'http://127.0.0.1:8545',
    fallbackAllowsWatchEvents: true,
    gtmEnvironment: GTM_ENVIRONMENTS.DEVELOPMENT,
    contracts: DeployedContracts
  },
  development_kovan: {
    id: NETWORK_IDS.KOVAN,
    name: NETWORK_NAMES.KOVAN,
    fallbackProvider: 'https://kovan.infura.io/v3/f09997a1257e4759b267dfc48850c776',
    fallbackAllowsWatchEvents: false,
    etherscanUrlPrefix: 'https://kovan.etherscan.io/tx/',
    gtmEnvironment: GTM_ENVIRONMENTS.DEVELOPMENT,
    contracts: DeployedContracts
  },
  development_rinkeby: {
    id: NETWORK_IDS.RINKEBY,
    name: NETWORK_NAMES.RINKEBY,
    fallbackProvider: 'https://rinkeby.infura.io/v3/a0a968c467234bc3ba0ca255b9edc3cb',
    fallbackAllowsWatchEvents: false,
    etherscanUrlPrefix: 'https://rinkeby.etherscan.io/tx/',
    gtmEnvironment: GTM_ENVIRONMENTS.DEVELOPMENT,
    contracts: DeployedContracts
  },
  development_ropsten: {
    id: NETWORK_IDS.ROPSTEN,
    name: NETWORK_NAMES.ROPSTEN,
    fallbackProvider: 'https://ropsten.infura.io/v3/729f2a837bd3493aac7988f2e609d495',
    fallbackAllowsWatchEvents: false,
    etherscanUrlPrefix: 'https://ropsten.etherscan.io/tx/',
    gtmEnvironment: GTM_ENVIRONMENTS.DEVELOPMENT,
    contracts: DeployedContracts
  },
  test_rinkeby: {
    id: NETWORK_IDS.RINKEBY,
    name: NETWORK_NAMES.RINKEBY,
    fallbackProvider: 'https://rinkeby.infura.io/v3/c139af2858cc411fbaa6d55a6cb4f4ea',
    fallbackAllowsWatchEvents: false,
    etherscanUrlPrefix: 'https://rinkeby.etherscan.io/tx/',
    gtmEnvironment: GTM_ENVIRONMENTS.STAGING,
    contracts: DeployedContracts
  },
  test_mainnet: {
    id: NETWORK_IDS.MAINNET,
    name: NETWORK_NAMES.MAINNET,
    fallbackProvider: 'https://mainnet.infura.io/v3/cc9e7d5fc50b4518bf59e643f4065d6c',
    fallbackAllowsWatchEvents: false,
    etherscanUrlPrefix: 'https://etherscan.io/tx/',
    gtmEnvironment: GTM_ENVIRONMENTS.STAGING,
    contracts: DeployedContracts
  },
  mainnet: {
    id: NETWORK_IDS.MAINNET,
    name: NETWORK_NAMES.MAINNET,
    fallbackProvider: 'https://mainnet.infura.io/v3/cc9e7d5fc50b4518bf59e643f4065d6c',
    fallbackAllowsWatchEvents: false,
    etherscanUrlPrefix: 'https://etherscan.io/tx/',
    gtmEnvironment: GTM_ENVIRONMENTS.PRODUCTION,
    contracts: DeployedContracts
  }
};
const network = networks.mainnet;

let contracts = {};

function initContract(web3) {
  Log.info('Initialising contract.');

  contracts.stickItem = web3.eth.contract(network.contracts.StickItem.abi).at(network.contracts.StickItem.address);
  contracts.stickItemType = web3.eth.contract(network.contracts.StickItemType.abi).at(network.contracts.StickItemType.address);
  contracts.stickItemTypeSale = web3.eth.contract(network.contracts.StickItemTypeSale.abi).at(network.contracts.StickItemTypeSale.address);
  contracts.stickItemTypeAuction = web3.eth.contract(network.contracts.StickItemTypeAuction.abi).at(network.contracts.StickItemTypeAuction.address);
}

export { network, contracts, initContract };



// WEBPACK FOOTER //
// ./src/config/blockchain.js